export enum UserRole {
  Owner = 'owner',
  Admin = 'admin',
  User = 'normal'
}
